import { defineComponent as _defineComponent } from 'vue'
import SettingsGroup from '@/components/layouts/SettingsGroup.vue';
import { computed, ref } from 'vue';
import { useSettingsBreadcrumbs } from '@/mixins/settings-breadcrumbs';
import SettingsForm from '@/components/layouts/SettingsForm.vue';
import { isModelEqualToModel, cloneModel } from '@/model/model-utils';
import { performSaveAction } from '@/services/vue-utils';
import AccountSettings from '@/model/AccountSettings';
import store from '@/store/store';
import useUnsavedGuard from '@/composables/unsaved-guard';
import useStoreWatch from '@/composables/store-watch';
import { ValidationObserver } from 'vee-validate';
import { emptySeatItems } from '@/components/views/settings/helpers/settings-values';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvancedSettings',
  setup(__props) {

const observerRef = ref(null as null | InstanceType<typeof ValidationObserver>);

const a = ref(new AccountSettings());
const olda = ref(new AccountSettings());
const seatItems = emptySeatItems();

//
const reset = () => {
  const acctSettings = store.state.settings.accountSettings;
  a.value = cloneModel(acctSettings);
  olda.value = acctSettings;
};
useStoreWatch(reset);

//
const isChanged = computed(() => !isModelEqualToModel(a.value, olda.value));
useUnsavedGuard(isChanged);

//
const save = async () => {
  const ok = await performSaveAction(
    observerRef.value,
    async () => store.dispatch('sendAccountSettings', { entity: a.value }),
  );

  if (ok) {
    reset();
  }
};


return { __sfc: true,observerRef, a, olda, seatItems, reset, isChanged, save, SettingsGroup, useSettingsBreadcrumbs, SettingsForm, ValidationObserver }
}

})